import React, { useState, useEffect } from 'react';
import { Payer, CreatePayerRequest, UpdatePayerRequest } from '../types';

interface PayerFormProps {
    payer?: Payer | null;
    onSubmit: (data: CreatePayerRequest | UpdatePayerRequest) => void;
    onCancel: () => void;
}

const PayerForm: React.FC<PayerFormProps> = ({ payer, onSubmit, onCancel }) => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        category: ''
    });

    useEffect(() => {
        if (payer) {
            setFormData({
                name: payer.name,
                description: payer.description,
                category: payer.category
            });
        }
    }, [payer]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSubmit(formData);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const categories = [
        'Essenciais',
        'Lazer',
        'Saúde',
        'Educação',
        'Transporte',
        'Alimentação',
        'Outros'
    ];

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <label htmlFor="name" className="block text-sm font-medium text-secondary-700 mb-1">
                    Nome *
                </label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="input-field"
                    placeholder="Digite o nome do pagador"
                />
            </div>

            <div>
                <label htmlFor="description" className="block text-sm font-medium text-secondary-700 mb-1">
                    Descrição *
                </label>
                <input
                    type="text"
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    required
                    className="input-field"
                    placeholder="Digite uma descrição"
                />
            </div>

            <div>
                <label htmlFor="category" className="block text-sm font-medium text-secondary-700 mb-1">
                    Categoria *
                </label>
                <select
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    required
                    className="input-field"
                >
                    <option value="">Selecione uma categoria</option>
                    {categories.map(category => (
                        <option key={category} value={category}>
                            {category}
                        </option>
                    ))}
                </select>
            </div>

            <div className="flex justify-end space-x-3 pt-4">
                <button
                    type="button"
                    onClick={onCancel}
                    className="btn-secondary"
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    className="btn-primary"
                >
                    {payer ? 'Atualizar' : 'Criar'}
                </button>
            </div>
        </form>
    );
};

export default PayerForm;




